export type LeadGenAdCopyIssue = {
  message: string;
};

const BLOCKED_PATTERNS: Array<{ pattern: RegExp; message: string }> = [
  {
    pattern:
      /\b(?:achieve|secure|ensur\w*|attain|reach)\b[^.!?]{0,60}\b(?:financial freedom|financial goals|retirement goals|retirement security)\b|\b(?:financial goals|legacy|retirement)\b[^.!?]{0,35}\b(?:are met|is secured|are secured|is guaranteed)\b|\b(?:asegur\w*|garantiz\w*|alcanz\w*)\b[^.!?]{0,50}\b(?:libertad financiera|metas financieras|jubilaci[oó]n)\b/i,
    message:
      "Describe exit-planning services without promising financial freedom, secured retirement, or financial goals being met.",
  },
  {
    pattern: /\bguarantee(?:d|s)?\b/i,
    message: "Meta ads can't promise a guaranteed sale, price, or result.",
  },
  {
    pattern: /\b(100%|risk[\s-]?free|no risk)\b/i,
    message: "Meta ads can't claim a risk-free or 100% outcome.",
  },
  {
    pattern: /\b(get rich|make \$\s?[\d,]+|income of|earn \$\s?[\d,]+)/i,
    message: "Meta ads can't make income or earnings claims.",
  },
  {
    pattern: /\bbefore\s*(and|&)\s*after\b/i,
    message: "Meta ads can't use before-and-after claims.",
  },
  {
    pattern:
      /\byou(?:'re| are| have been)?\s+(struggling|in debt|depressed|divorcing|sick|old|poor)\b/i,
    message:
      "Meta ads can't call out a person's financial, health, or personal situation.",
  },
  {
    pattern: /\bsecret (buyer|formula|method|trick)s?\b/i,
    message: "Meta ads can't use sensational or secret-method claims.",
  },
];

/** Fast, conservative scan for copy Meta is likely to reject. */
export function scanLeadGenAdCopy(
  texts: readonly string[],
): LeadGenAdCopyIssue[] {
  const issues: LeadGenAdCopyIssue[] = [];
  const seen = new Set<string>();
  for (const text of texts) {
    const value = text.trim();
    if (!value) continue;
    for (const rule of BLOCKED_PATTERNS) {
      if (!rule.pattern.test(value) || seen.has(rule.message)) continue;
      seen.add(rule.message);
      issues.push({ message: rule.message });
    }
  }
  return issues;
}
